import React from 'react';
import { Modal } from '@kallidus/common';
import { func, object } from 'prop-types';
import SessionOutForm from './SessionOutForm';

export default function SessionOutModal({ onIdle, value, ...modalProps }) {
  //I intentionally used <Form /> in a <Modal /> instead of <FormModal /> because my form take its value from browser.
  // formstate not update in a single loop. First email update in formstate and after that password update. That's why I kept my form in useMemo.

  return (
    <Modal footer={React.Fragment} closeIcon={React.Fragment} maskClosable={false} {...modalProps}>
      <SessionOutForm onIdle={onIdle} onClose={modalProps.onClose} loginOptions={value?.loginOptions} />
    </Modal>
  );
}

SessionOutModal.propTypes = {
  onIdle: func,
  value: object,
};
